module.exports = __webpack_public_path__ + "static/media/ACC_F1.edf2006a.txt";